import React, { Component, forwardRef } from "react";
import MaterialTable, { Column } from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import axios from "axios";
import { ListItemAvatar, Typography, Table, TableHead, TableRow, TableBody, TableCell, withStyles, createStyles, Theme } from "@material-ui/core";
import PrivateComponent from "../Component2/PrivateComponent";
import WS from "../../Config/WS";
import Tabela from "../Tabela/Tabela";
import { AppState } from "../../reducer/ReducerTypes";
import { connect } from "react-redux";
import { SetLinhaProduto } from "../../reducer/ActionsCreator";
import { Store } from "../../reducer/Reducer";
import Component2, { EmptyBaseState } from "../Component2/Component2";
import NocRequest from "../../utils/NocRequest";
import { IControllerResult } from "../../controllers/Types";
import Formatter from "../../utils/Formatters";
import SubjectIcon from '@material-ui/icons/Subject';
import { withRouter } from "react-router-dom";
import Tabela2 from "../Tabela/Tabela2";

const tableIcons: any = {
    Add: forwardRef((props, ref:any) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref:any) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref:any) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref:any) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref:any) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref:any) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref:any) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref:any) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref:any) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref:any) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref:any) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref:any) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref:any) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref:any) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref:any) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref:any) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref:any) => <ViewColumn {...props} ref={ref} />),
    AddVersao: forwardRef((props, ref:any) => <AddCircleIcon {...props} ref={ref} />),
    Subject: forwardRef((props, ref:any) => <SubjectIcon {...props} ref={ref} />),
};

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }),
)(TableCell);

interface IProps {
    appstate?: AppState;
    linhaproduto: string;
    SetLinhaProduto?: (linhaproduto: string) => void;
}
interface IDetailRender {
    [Name: string]: any;
}
interface IState {
    modelo: number;
    detailRender: any[];
}
const sistema = (field: string) => (data: any) => {
    let c = data[field];
    return (c == -1 ? <span title={data['vc_'+field] ? "Versão "+data['vc_'+field] : "Versão não informada"} style={{color: 'red'}}>Sim</span> : (c == 1 ? "" : 
                      <span title={data['vc_'+field] ? "Versão "+data['vc_'+field] : "Versão não informada"} style={{color: 'green'}}>Não</span>))
}
class VersoesTransmitidas extends PrivateComponent<IProps, IState> {
    constructor(props: any) {
        super(props);
        this.rowClick = this.rowClick.bind(this);
        this.consulta = this.consulta.bind(this);
        this.getExtraInfo = this.getExtraInfo.bind(this);
        this.state = {
            ...EmptyBaseState,
            modelo: 1,
            detailRender: [],
        }
    }
    componentDidMountPrivate() {
        this.getExtraInfo();
    }
    rowClick(event: any, rowData: any) {
        //RowClick(event, rowData, this.props.doError);
    }
    modelo() {
        //this.estado({modelo: this.state.modelo+1 > 2 ? 1 : this.state.modelo+1, refreshCount: this.state.refreshCount+1});
        this.addRefreshCount({modelo: this.state.modelo+1 > 2 ? 1 : this.state.modelo+1});
    }
    consulta(query: any) {
        let order = (query?.orderBy?.field || 'datahora') + ' ' + (query?.orderDirection || 'desc');
        let search: string = query?.search || '';
        let field: string = query?.field || '';
        let where: string = "";
        where = field == "" ? `
            where  false
            or upper(empresa::text) like '%${search.toUpperCase()}%'
            or upper(loja::text) like '%${search.toUpperCase()}%'
            or upper(cnpj::text) like '%${search.toUpperCase()}%'
            or upper(codigosistema::text) like '%${search.toUpperCase()}%'
            or upper(descricao::text) like '%${search.toUpperCase()}%'
            or upper(so_data::text) like '%${search.toUpperCase()}%'
        ` : `
            where  upper(${field}::text) like '%${search.toUpperCase()}%'
        `;
    
        let Sql = `
            select * from (
                select s.*, ts.descricao from sistemas s
                left join tiposistema ts on ts.linhaproduto=s.linhaproduto and ts.codigo=s.codigosistema
            ) as con2
            ${where}
            order by ${order}          
        `;
        //console.log(Sql);

        return new Promise<any>(async(resolve, reject) => {
            let result: any = await axios.post(WS.URL_NOC + "entity/sqlpage", {
                sql: Sql,
                page: query.page,
                pageSize: query.pageSize,
                search: query.search,
                orderBy: ""
            })
    
            resolve({
                data: result?.data?.data,
                page: result?.data?.page-1,
                totalCount: result?.data?.total
            });
        })   
    }
    async getExtraInfo() {
        /*let Sql2 = `
            select idcliente, codigosistema, idsprint, idorservico, iddetalhe, descricaoos, detalheos
            from view_proximasatualizacoes
            where true
                and linhaproduto = '${this.props.linhaproduto}' 
            order by idorservico
        `;
        let result2: any = await axios.post(WS.URL_NOC + "entity/sqlpage", {
            sql: Sql2,
            page: 1,
            pageSize: 20000,
            search: "",
            orderBy: ""
        });
        this.estado({detailRender: result2?.data?.data}); */
    }
    renderPrivate() {
        return (
            <div style={{ maxWidth: "100%", width: '100%' }}>
                <Tabela2
                    // icons={tableIcons}
                    actions={[
                        
                    ]}
                    columns={[
                        { title: "Empresa", field: "empresa" },
                        { title: "Loja", field: "loja" },
                        { title: "CNPJ", field: "cnpj" },
                        { title: "Linha Produto", field: "linhaproduto" },
                        { title: "Código", field: "codigosistema" },
                        { title: "Sistema", field: "descricao" },
                        { title: "Versão", field: "versao" },
                        { title: "Horário", field: "datahora", render: Formatter.date("datahora", "d-m-Y h:n:s") },
                        { title: "SO", field: "so_data" },
                        { title: "Último Acesso", field: "ultimoacesso", render: Formatter.date("ultimoacesso", "d-m-Y h:n:s") },
                    ]}
                    fieldsSelect={[
                        "empresa", "loja","cnpj","linhaproduto","codigosistema","descricao","versao","so_data"
                    ]}
                    data={this.consulta}
                    // options={{
                    //     searchFieldAlignment: 'right',
                    //     minBodyHeight: 'calc(100vh - 200px)',
                    //     maxBodyHeight: 'calc(100vh - 200px)',
                    //     pageSize: 30,
                    //     pageSizeOptions: [9, 20, 30, 50, 100],
                    //     search: true,
                    // }}
                    // search2={true}
                    orderByField="datahora"
                    orderByDirection="desc"
                    search={true}
                    pageSize={10}
                    refreshCount={this.state.refreshCount}
                    // onSearchChange={(txt: string) => { console.log(txt); }}
                    // onQueryChange={() => { console.log('query changed') }}

                    title={"Versões Transmitidas"}
                    // onRowClick={this.rowClick/*RowClick*/}
                    // localization={{
                    //     header: {
                    //         actions: ""
                    //     }
                    // }}
                    // detailPanel={[1, 2, 3].indexOf(this.state.modelo) == -1 ? null as any : (data: any) => this.getDetailRender(data)}
                    //onTreeExpandChange={(data: any) => this.getDetail(data)}
                    
                />
                {this.baseRender()}
            </div>
        );
    }
    getDetailRender(data: any) {
        /*
        if (this.state.detailRender.length > 0) {
            return <div>
                <Table>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell size="small">&nbsp;</StyledTableCell>
                            <StyledTableCell size="small">O.S.</StyledTableCell>
                            <StyledTableCell size="small">Descrição</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.state.detailRender.map((rowData: any, index: number) => {
                            if (
                                (([1, 3].indexOf(this.state.modelo) >= 0) && (rowData.codigosistema == data.codigosistema) && (rowData.idsprint == data.idsprint) && (rowData.idcliente == data.idcliente)) ||
                                (([2].indexOf(this.state.modelo) >= 0) && (rowData.idcliente == data.idcliente))
                            )
                                return ([
                                    <TableRow>
                                        <TableCell size="small" className="green">&nbsp;</TableCell>
                                        <TableCell size="small" className="green">{rowData.idorservico}</TableCell>
                                        <TableCell size="small" className="green">{rowData.descricaoos}</TableCell>
                                    </TableRow>,
                                    <TableRow>
                                        <TableCell size="small" className="green">&nbsp;</TableCell>
                                        <TableCell size="small" className="green">&nbsp;</TableCell>
                                        <TableCell size="small" className="green">{rowData.detalheos}</TableCell>
                                    </TableRow>
                                ]);
                        })}

                    </TableBody>
                </Table>
            </div>;

        }
        else {
            return <div>
                <Table>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell size="small">&nbsp;</StyledTableCell>
                            <StyledTableCell size="small">O.S.</StyledTableCell>
                            <StyledTableCell size="small">Descrição</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                                <TableCell size="small" colSpan={3}>aguardando a carga dos dados</TableCell>
                                
                        </TableRow>
                    </TableBody>
                </Table>
            </div>;
        }
        */
    }

}

const mapStateToProps = (state: AppState, ownProps: any) => {
    return {appstate: state};
}
const mapDisptachToProps = (dispatch: any, ownProps: any) => {
    return {
        ...ownProps,
        SetLinhaProduto: (linhaproduto: string) => dispatch(SetLinhaProduto(linhaproduto)),
    };
}

const CVersoesTransmitidas = connect(mapStateToProps)(VersoesTransmitidas);
export default CVersoesTransmitidas;
